import React from 'react'
import { MessageBar, MessageBarBody, MessageBarTitle, Skeleton, SkeletonItem, TableColumnDefinition, makeStyles, mergeClasses, shorthands, tokens } from '@fluentui/react-components'
import { Text } from '../text/Text'
import { Card } from '../card/Card'
import { CustomList } from '../list/CustomList'

const useStyles = makeStyles({
   beigeRounded: {
      backgroundColor: '#FFFDF5',
      ...shorthands.borderRadius(tokens.borderRadiusLarge),
      boxShadow: tokens.shadow8,
   },
   mobileList: {
      display: 'none',
      '@media screen and (max-width: 1007px)': {
         display: 'flex',
         flexDirection: 'column',
         ...shorthands.gap(tokens.spacingHorizontalS),
         ...shorthands.margin(tokens.spacingHorizontalS, 0),
      },
   },
   mobileListElement: {
      ...shorthands.padding(0, tokens.spacingHorizontalXL),
      height: 'auto',
      display: 'flex',
      alignContent: 'center',
      justifyContent: 'space-between',
      cursor: 'pointer',
   },
   hideInPhone: {
      '@media screen and (max-width: 1007px)': {
         display: 'none',
      },
   },
   skeletonRow: {
      display: 'flex',
      gap: tokens.spacingHorizontalM,
      padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
   },
})

type OverviewProps<T extends {}> = {
   columns: TableColumnDefinition<T>[]
   onRowClick: (item: T) => void
   items: T[]
   title: string
   loading: boolean
   keyValue: keyof T
   noItemsText: string
   rowClassName: string
   renderMenuButton?: (item: T) => JSX.Element
}
export const Overview = <T extends {}>({
   onRowClick,
   items,
   columns,
   title,
   loading,
   keyValue,
   noItemsText,
   rowClassName,
   renderMenuButton,
}: OverviewProps<T>) => {
   const classes = useStyles()

   return (
      <>
         {loading ? (
            <Card className={mergeClasses(classes.hideInPhone)} title="">
               <Skeleton>
                  {Array.from({ length: 6 }).map((_, i) => (
                     <div key={i} className={classes.skeletonRow}>
                        <SkeletonItem size={16} style={{ flex: 5 }} />
                        <SkeletonItem size={16} style={{ flex: 2 }} />
                        <SkeletonItem size={16} style={{ flex: 2 }} />
                     </div>
                  ))}
               </Skeleton>
            </Card>
         ) : items.length > 0 ? (
            <>
               <Card className={mergeClasses(classes.hideInPhone)} title={title}>
                  <CustomList beigeHeaderBackground columns={columns} items={items} onRowClick={onRowClick} rowClassName={rowClassName} />
               </Card>
               <section className={classes.mobileList}>
                  {items.map((item: T, i) => {
                     return (
                        <span key={i} className={mergeClasses(classes.mobileListElement, classes.beigeRounded)} onClick={() => onRowClick(item)}>
                           <Text>{item[keyValue] as string}</Text>
                           {renderMenuButton && renderMenuButton(item)}
                        </span>
                     )
                  })}
               </section>
            </>
         ) : (
            <MessageBar>
               <MessageBarBody>
                  <MessageBarTitle>{noItemsText}</MessageBarTitle>
               </MessageBarBody>
            </MessageBar>
         )}
      </>
   )
}
